export default {
	isAuthenticated: (state) => {
		return state.isAuthenticated;
	},
	getUsername: (state) => {
		return state.user.profile.name;
	},
	getRole: (state) => {
		return state.userInfo.role;
	},
	//websocket
	getWebsocket: (state) => {
		return state.websocket;
	},
	getUserInfo: (state) => {
		return state.userInfo;
	},
	getUserForEdition: (state) => {
		return state.userForEdition;
	},
	getSnackBar: (state) => {
		return state.snackBar;
	},
	getSnackText: (state) => {
		return state.snackText;
	},
	getSnackParameter: (state) => {
		return state.snackParameter;
	},
	getDisplayDrawer: (state) => {
		return state.displayDrawer;
	},
	getDetailedProject: (state) => {
		return state.detailedProject;
	},
	getProjectRaw: (state) => {
		return state.projectRaw;
	},

	getProject: (state) => {
		return state.projectForDetailsPage;
	},

	getAuditDialog: (state) => {
		return state.auditDialog;
	},
	getAuditResult: (state) => {
		return state.auditResult;
	},
	getIsLegalAudit: (state) => {
		return state.isLegalAudit;
	},
	getAuditProject: (state) => {
		return state.auditProject;
	},
	//snack downloads
	getSnackDownload(state) {
		return state.snackDownload;
	},
	getSelected(state) {
		return state.selected;
	},
	getProjectDownload(state) {
		return state.projectDownload;
	},
	getDownloadInProgress(state) {
		return state.downloadInProgress;
	},
	getSearch(state) {
		return state.search;
	},
	getSearchInterval(state) {
		return state.searchInterval;
	},
	getPage(state) {
		return state.page;
	},
	getActualPage(state) {
		return state.actualPage;
	},

	getWindowWidth(state) {
		return state.windowWidth;
	},
	getOrganismEdition(state) {
		return state.organismEdition;
	},
	getIsOrganismEditMode(state) {
		return state.isOrganismEditMode;
	},
	getUpdateProjectViewer(state) {
		return state.updateProjectViewer;
	},
	getFooterKey(state) {
		return state.footerKey;
	},
	getStatus(state) {
		return state.status;
	},
	//calendar
	getSelectedStatistic(state) {
		return state.selectedStatistic;
	},
	getSelectedItemsPerPage(state) {
		return state.selectedItemsPerPage;
	},
	getStartDate(state) {
		return state.startDate;
	},
	getRange(state) {
		return state.range;
	},
	//progress download
	getProgressDownload: (state) => {
		return state.progressDownload;
	},

	getMakeRequest(state) {
		return state.makeRequest;
	},
	getDisabledText(state) {
		return state.disableText;
	},
	getSecodaryUpdate(state) {
		return state.secodaryUpdate;
	},
	getStatusKey(state) {
		return state.statusKey;
	},
};
